import { render, staticRenderFns } from "./rank-4k.vue?vue&type=template&id=4b8de79e&scoped=true"
import script from "./rank-4k.vue?vue&type=script&lang=js"
export * from "./rank-4k.vue?vue&type=script&lang=js"
import style0 from "./rank-4k.vue?vue&type=style&index=0&id=4b8de79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8de79e",
  null
  
)

export default component.exports